export default __webpack_public_path__ + "static/media/PNG.f1e1768e.svg";